import { PartialCarConfiguration } from '~/app/market-config/models/car-confi-market-configuration';

const q4: PartialCarConfiguration = {
	combinations: ['trimLine', 'packages', 'paint', 'rims', 'headlights', 'interiorPackages', 'steeringWheels'],
};

const q4etron_2024_F4: PartialCarConfiguration = {
	...q4,
};

const q4sbetron_2024_F4: PartialCarConfiguration = {
	...q4,
};

export { q4etron_2024_F4, q4sbetron_2024_F4 };
